import React from 'react';
import Auth from 'j-toker';
import ButtonSwitchNavigation from 'components/shared/ButtonSwitchNavigation';
import { MdSearch as SearchIcon, MdPersonAdd as NewIcon } from 'react-icons/md';
import Header from 'components/shared/Header';
import * as validator from 'helpers/Validator';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { displayLeads } from 'actions/landlordLeadsActions';
import { formatPhone } from 'helpers/Formatter';
import SearchInput from 'helpers/reduxFormMaterialUiNext/SearchInput';
import { Card } from 'material-ui/Card';
import SlideDownAnimation from 'components/shared/SlideDownAnimation';
import LeadCardForm from 'components/landlord_app/leads/components/LeadCardForm';
import { ProspectStatus } from 'components/shared/StatusHelper';
import { fetchCurrentLeasesForSingleUnits } from 'helpers/PropertiesHelper';
import { getProperty, getUnitTypes } from 'actions/landlordPropertiesActions';
import { apiGet } from 'helpers/ApiHelper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getTranslatedString } from 'helpers/i18n';

const styles = {
  avatar: {
    borderRadius: 100,
    width: 100,
    height: 100,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    float: 'right',
  },
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '5px',
  },
};

const DEBOUNCING_DELAY = 1000;

class LeadCardPicker extends React.Component {
  state = {
    selectedIndex: 0,
    residentSearchLoading: false,
    residentsSearchResult: [],
    selectedResident: null,
    leadCardSearchLoading: false,
    leadCardsSearchResult: [],
    selectedLeadCard: null,
  };

  componentWillUnmount() {
    clearTimeout(this.residentSearchTimeout);
    clearTimeout(this.leadCardSearchTimeout);
  }

  handleButtonSwitched = (selectedIndex) => {
    let newState = {};
    if (selectedIndex !== 0) {
      this.props.changeFormValue(this.props.formName, 'lead_card_id', null);
      newState['selectedLeadCard'] = null;
      newState['leadCardsSearchResult'] = [];
    }
    if (selectedIndex !== 1) {
      this.props.changeFormValue(this.props.formName, 'cotenant_id', null);
      newState['selectedResident'] = null;
      newState['residentsSearchResult'] = [];
    }
    this.setState({ selectedIndex, ...newState });
  };

  handleResidentSearch = (query) => {
    if (!query) return; // don't search when query is blank

    clearTimeout(this.residentSearchTimeout);
    this.props.changeFormValue(this.props.formName, 'cotenant_id', null);
    this.setState({
      residentSearchLoading: true,
      residentsSearchResult: [],
      selectedResident: null,
    });
    this.residentSearchTimeout = setTimeout(() => {
      apiGet(Auth.getApiUrl() + `/landlords/tenants/search?query=${encodeURIComponent(query)}`)
        .then((resp) => {
          this.setState({
            residentsSearchResult: resp.search_result.map((resident) => {
              return {
                text: `${resident.full_name} - ${resident.property_name} Unit ${resident.unit_number}`,
                value: resident.id,
                ...resident,
              };
            }),
            residentSearchLoading: false,
          });
        })
        .catch((error) => {
          this.setState({ residentSearchLoading: false });
        });
    }, DEBOUNCING_DELAY);
  };

  handleResidentSelect = (selectedItem) => {
    this.setState({
      selectedResident: selectedItem,
    });
  };

  handleLeadCardSearch = (query) => {
    if (!query) return; // don't search when query is blank

    clearTimeout(this.leadCardSearchTimeout);
    this.props.changeFormValue(this.props.formName, 'lead_card_id', null);
    this.setState({
      leadCardSearchLoading: true,
      leadCardsSearchResult: [],
      selectedLeadCard: null,
    });
    this.leadCardSearchTimeout = setTimeout(() => {
      apiGet(Auth.getApiUrl() + `/landlords/lead_cards/search?query=${encodeURIComponent(query)}`)
        .then((resp) => {
          this.setState({
            leadCardsSearchResult: resp.search_result.map((leadCard) => {
              return {
                text: `${leadCard.full_name} (${leadCard.property_name})`,
                value: leadCard.id,
                ...leadCard,
              };
            }),
            leadCardSearchLoading: false,
          });
        })
        .catch((error) => {
          this.setState({ leadCardSearchLoading: false });
        });
    }, DEBOUNCING_DELAY);
  };

  handleLeadCardSelect = (leadCard) => {
    this.setState({
      selectedLeadCard: leadCard,
    });
    this.props.changeFormValue(this.props.formName, 'property', leadCard.property);
    if (leadCard.property && leadCard.property.value) {
      const property_id = leadCard.property.value;
      this.props.getProperty(property_id);
      this.props.getUnitTypes(property_id);
      this.props.clearCurrentLeasesOfUnit();
      this.props.changeFormValue(this.props.formName, 'unit_selected', null);
      this.props.changeFormValue(this.props.formName, 'unit_type_selected', null);

      // Only show the only_rentables if the landlord is yardi enabled.
      this.props
        .getUnits(property_id, { for_multiselect: true, only_rentables: this.props.yardiEnabled })
        .then((response) => {
          fetchCurrentLeasesForSingleUnits(
            response.value.data,
            this.props.getCurrentLeasesOfUnit,
            (field, value) => {
              this.props.changeFormValue(this.props.formName, field, value);
            },
            this.props.getUnitDetails
          );
        });
    }
  };

  render() {
    return (
      <div>
        <Header name="APPLICANT" style={{ marginBottom: '15px' }} />
        <ButtonSwitchNavigation
          buttonLabels={[
            getTranslatedString('landlordPortal.leadCardPicker.searchProspect'),
            getTranslatedString('landlordPortal.leadCardPicker.searchResident'),
            getTranslatedString('landlordPortal.leadCardPicker.createNewLead'),
          ]}
          buttonIcons={[<SearchIcon />, <SearchIcon />, <NewIcon />]}
          handleChange={this.handleButtonSwitched}
        />
        <SlideDownAnimation>{this.renderFindLeadCard()}</SlideDownAnimation>
        <SlideDownAnimation>{this.renderFindResident()}</SlideDownAnimation>
        <SlideDownAnimation>{this.renderCreateNewLeadCard()}</SlideDownAnimation>
      </div>
    );
  }

  renderFindLeadCard = () => {
    if (this.state.selectedIndex !== 0) return;

    return (
      <div className="row">
        <div className="col-xs-12" style={{ marginBottom: '20px' }}>
          <Field
            fullWidth
            name="lead_card_id"
            component={SearchInput}
            hintText={getTranslatedString('landlordPortal.leadCardPicker.searchByName')}
            dataSource={this.state.leadCardsSearchResult}
            onUpdateInput={this.handleLeadCardSearch}
            onNewRequest={this.handleLeadCardSelect}
            validate={[validator.required]}
            textFieldStyle={{ fontSize: '14px' }}
          />
          {this.state.leadCardSearchLoading && (
            <CircularProgress
              size={25}
              style={{ float: 'right', position: 'relative', top: '-40px', marginBottom: '-40px' }}
            />
          )}
          <SlideDownAnimation>{this.renderPreviewLeadCard()}</SlideDownAnimation>
        </div>
      </div>
    );
  };

  renderFindResident = () => {
    if (this.state.selectedIndex !== 1) return;

    return (
      <div className="row">
        <div className="col-xs-12" style={{ marginBottom: '20px' }}>
          <Field
            fullWidth
            name="cotenant_id"
            component={SearchInput}
            hintText={getTranslatedString('landlordPortal.leadCardPicker.searchByName')}
            dataSource={this.state.residentsSearchResult}
            onUpdateInput={this.handleResidentSearch}
            onNewRequest={this.handleResidentSelect}
            validate={[validator.required]}
            textFieldStyle={{ fontSize: '14px' }}
          />
          {this.state.residentSearchLoading && (
            <CircularProgress
              size={25}
              style={{ float: 'right', position: 'relative', top: '-40px', marginBottom: '-40px' }}
            />
          )}
          <SlideDownAnimation>{this.renderPreviewResident()}</SlideDownAnimation>
        </div>
      </div>
    );
  };

  renderPreviewResident = () => {
    const resident = this.state.selectedResident;
    if (!resident) return;

    return (
      <div style={{ marginTop: '15px' }}>
        <Card style={styles.transactionCard}>
          <div className="row" style={{ margin: '15px 15px 0' }}>
            <div className="col-xs-6" style={{ paddingLeft: 0 }}>
              <h3 style={{ marginTop: 0, fontFamily: 'Circular-Bold' }}>{resident.full_name}</h3>
              <h5 style={{ marginTop: 0, overflowWrap: 'break-word' }}>{resident.email}</h5>
              <h5 style={{ marginTop: 0 }}>{formatPhone(resident.phone_number)}</h5>
              <h5 style={{ marginTop: 0 }}>
                {getTranslatedString('landlordPortal.leadCardPicker.existingResident')}
              </h5>
            </div>
            <div className="col-xs-6" style={{ paddingRight: 0 }}>
              <div
                style={{
                  ...styles.avatar,
                  backgroundImage: `url(https://s3.ca-central-1.amazonaws.com/prod-ca-central-1/leads/avatars/missing/medium/missing_avatar.jpg)`,
                }}
              />
            </div>
          </div>
          <div className="row" style={{ marginBottom: '15px' }}>
            <div className="col-xs-12">
              <span style={{ color: 'rgba(0,0,0,0.4)' }}>
                {resident.property_name}{' '}
                {getTranslatedString('landlordPortal.leadCardPicker.atUnit')} {resident.unit_number}
              </span>
            </div>
          </div>
        </Card>
      </div>
    );
  };

  renderPreviewLeadCard = () => {
    const { selectedLeadCard } = this.state;
    if (!selectedLeadCard) return;

    return (
      <div style={{ marginTop: '15px' }}>
        <Card style={styles.transactionCard}>
          <div className="row" style={{ margin: '15px 15px 0' }}>
            <div className="col-xs-6" style={{ paddingLeft: 0 }}>
              <h3 style={{ marginTop: 0, fontFamily: 'Circular-Bold' }}>
                {selectedLeadCard.full_name}{' '}
                <ProspectStatus status={selectedLeadCard.status_verbiage} />
              </h3>
              <h5 style={{ marginTop: 0, overflowWrap: 'break-word' }}>{selectedLeadCard.email}</h5>
              <h5 style={{ marginTop: 0 }}>{formatPhone(selectedLeadCard.phone_number)}</h5>
              <h5 style={{ marginTop: 0 }}>{selectedLeadCard.status_verbiage}</h5>
            </div>
            <div className="col-xs-6" style={{ paddingRight: 0 }}>
              <div
                style={{
                  ...styles.avatar,
                  backgroundImage: `url(https://s3.ca-central-1.amazonaws.com/prod-ca-central-1/leads/avatars/missing/medium/missing_avatar.jpg)`,
                }}
              />
            </div>
          </div>
          <div className="row" style={{ marginBottom: '15px' }}>
            <div className="col-xs-12">
              <span style={{ color: 'rgba(0,0,0,0.4)' }}>
                {getTranslatedString('landlordPortal.leadCardPicker.lookingFor')}{' '}
                {selectedLeadCard.desired_unit_type}
              </span>
            </div>
          </div>
        </Card>
      </div>
    );
  };

  renderCreateNewLeadCard = () => {
    if (this.state.selectedIndex !== 2) return;

    return (
      <div className="row" style={{ marginBottom: '10px' }}>
        <LeadCardForm
          properties={this.props.properties}
          trafficSources={this.props.trafficSources}
          requireEmail={false}
          minimumApplicantAge={this.props.minimumApplicantAge}
        />
      </div>
    );
  };
}

export default connect(
  (store) => {
    return {
      yardiEnabled: store.userTypes.yardiEnabled,
      userPreferences: store.userTypes.userPreferences,
      minimumApplicantAge: store.companyDetails.companyPreferences.minimum_applicant_age,
    };
  },
  {
    displayLeads,
    changeFormValue: change,
    getProperty,
    getUnitTypes,
  }
)(LeadCardPicker);
